import FreeLessons from "../../components/FreeLessons/FreeLessons";
import { HeroSection } from "../../components/HeroSection/Hero";
import HowItWorks from "../../components/HowWork/HowWork";
import PromotionalBanner from "../../components/PromotionalBanner/PromotionalBanner";
import Subjects from "../../components/Subjects/Subjects";
import Ads from "../../components/Ads/Ads";
import TrustedBy from "../../components/TrustedBy/TrustedBy";
import Teachers from "../../components/Teachers/Teachers";
import ParentTestimonial from "../../components/ParentTestimonial/ParentTestimonial";
import QuestionAndAnswers from "../../components/QuestionAndAnswer/QuestionAndAnswer";
import { Features } from "../../components/Features/Features";
import MobileAdsStore from "../../components/MobileAdsStore/MobileAdsStore";
import QuickStats from "../../components/QuickStats/QuickStats";
import EidMiladBanner from "../../components/EidMiladBanner";
import { useSelector } from "react-redux";

function Home() {
    const { currentUser } = useSelector((state) => state.auth);
    const userRole = currentUser?.role || localStorage.getItem("userRole");
    
    return <>
    <EidMiladBanner />
    <HeroSection />
    <Features />
    {userRole !== "teacher" && userRole !== "parent" && <QuickStats />}
    {userRole !== "parent" && <Subjects />}
    {userRole !== "parent" && <PromotionalBanner />}
    <FreeLessons />
    <HowItWorks />
    <TrustedBy />
    <Ads />
    <Teachers />
    <ParentTestimonial />
    <MobileAdsStore />
    <QuestionAndAnswers />
    </>
}
export default Home;